import { memo } from 'react';
import JsonNode from './JsonNode';
import { useJsonTreeStyles } from './JsonNode';

interface JsonTreeViewProps {
  data: unknown;
  expandVersion: number;
}

const JsonTreeView = memo(function JsonTreeView(props: JsonTreeViewProps) {
  const { data, expandVersion } = props;
  const classes = useJsonTreeStyles();

  if (data === null || typeof data !== 'object') {
    return <JsonNode value={data} depth={0} defaultExpanded expandVersion={expandVersion} />;
  }

  const isArray = Array.isArray(data);
  const entries = isArray
    ? (data as unknown[]).map((v, i) => [i, v] as const)
    : Object.entries(data as Record<string, unknown>);
  const openBracket = isArray ? '[' : '{';
  const closeBracket = isArray ? ']' : '}';

  return (
    <div>
      <div className={classes.nodeRow}>
        <span className={classes.togglePlaceholder} />
        <span className={classes.nodeBracket}>{openBracket}</span>
      </div>
      {entries.map(([k, v], idx) => (
        <JsonNode
          key={String(k)}
          nodeKey={k}
          value={v}
          depth={1}
          defaultExpanded={expandVersion >= 0}
          expandVersion={expandVersion}
          isLast={idx === entries.length - 1}
        />
      ))}
      <div className={classes.nodeRow}>
        <span className={classes.togglePlaceholder} />
        <span className={classes.nodeBracket}>{closeBracket}</span>
      </div>
    </div>
  );
});

export default JsonTreeView;
